import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { CheckCircle, Spinner } from 'phosphor-react';

const BuyButton = ({
  label,
  articleNumber,
  quantity,
  href,
  cssClass,
  disabledClass = 'buy-button--disabled',
  onClick,
}) => {
  return (
    <Fragment>
      <a
        className={`${cssClass ?? 'buy-button'} ${
          !articleNumber ? 'disabled' : ''
        }`}
        onClick={(e) => {
          e.preventDefault();
          onClick({ articleNumber, quantity });
        }}
        href={href}
        disabled={!articleNumber}
      >
        <span style={{ height: '1rem' }} className="buy-button__label--regular">
          {label}
        </span>
        <span style={{ height: '1rem' }} className="buy-button__label--loading">
          <Spinner size={16} weight="fill">
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="1s"
              from="0 0 0"
              to="360 0 0"
              repeatCount="indefinite"
            ></animateTransform>
          </Spinner>
        </span>
        <span style={{ height: '1rem' }} className="buy-button__label--success">
          <CheckCircle size={16} weight="fill" />
        </span>
      </a>
    </Fragment>
  );
};

const StyledButton = (props) => {
  const dispatch = useDispatch();
  const onClick = async ({ articleNumber, quantity }) => {
    try {
      const cart = await addToCartService({ articleNumber, quantity });
      dispatch(receive(cart));
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };
  const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
  return <Button {...props} minimumLoadingTime={200} />;
};

export default StyledButton;
